// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__KQrAP","pre":"styles_pre__Rrlkc","slideWrapper":"styles_slideWrapper__qjnxd"};